import { createWorkerAction } from '../lib';
export var performanceApplicationLoaded = createWorkerAction('PERFORMANCE_APPLICATION_LOADED');
